<template>
    <section class="card mb-2">
        <FormSection title="DME" :full-height="false">
            <template #content>
                <div class="row m-2">
                    <div class="col-12 col-md-4" v-for="(vendor, index) in patientVendors">
                        <PatientVendor
                            v-model:vendor-id="patientVendors[index]"
                            :provider-id="providerId"
                            v-model:patient-vendors="patientVendors"
                            :vendor-types="vendorTypes"
                            card-title="DME Vendor"
                        ></PatientVendor>
                    </div>
                    <div class="col-12 mt-2">
                        <button
                            class="btn btn-outline-primary"
                            @click="addNewVendor()"
                            :disabled="!!patientVendors && patientVendors.length >= 5"
                        >
                            <i class="fas fa-plus"></i> Add DME Vendor
                        </button>
                    </div>
                </div>
                <div class="row p-2">
                    <div class="col-12 d-flex">
                        <button
                            type="button"
                            class="btn btn-primary btn-xs ms-auto mb-2"
                            v-if="!isEditAllowed"
                            @click="updateDmes()"
                        >
                            Update DME
                        </button>
                    </div>
                    <div class="col-12 col-md-6" v-if="isEditAllowed">
                        <div class="form-group row">
                            <label
                                for="medicare-number"
                                class="col-form-label col-12 col-md-5 text-md-end text-sm-start"
                                >Select DME
                            </label>
                            <div class="col-12 col-md-7">
                                <TypeaheadInput
                                    :getData="getDMEList"
                                    :value="selectionDme"
                                    :disabled="showDmeInputRow"
                                    :open-on-focus="true"
                                    v-on:valueChanged="selectionDmeChanged"
                                ></TypeaheadInput>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <table class="table table-responsive-md border border-gray">
                            <thead>
                                <tr class="bg-table-header">
                                    <th>Equipment Name</th>
                                    <th>Infusion Pump</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th class="text-end">Actions</th>
                                </tr>
                            </thead>
                            <!-- EMPTY -->
                            <tbody v-if="dmes.length == 0 && !showDmeInputRow">
                                <TableEmpty
                                    :col-span="columns"
                                    component="dme"
                                    secondary-message="No DME Added"
                                ></TableEmpty>
                            </tbody>
                            <!-- NEW -->
                            <tbody v-if="showDmeInputRow">
                                <DMETableRow
                                    :dme="savetoAdd"
                                    :is-new-dme="true"
                                    :update-dme="saveNewDme"
                                    :cancel-new-dme="cancelNewDme"
                                    :columns="columns"
                                >
                                </DMETableRow>
                            </tbody>
                            <!-- DATA -->
                            <tbody v-for="dme in dmes">
                                <DMETableRow
                                    :dme="dme"
                                    :update-dme="updateDme"
                                    :delete-dme-from-list="deleteDmeFromList"
                                >
                                </DMETableRow>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </FormSection>
    </section>
</template>

<script lang="ts" src="./PatientDme.ts"></script>
